<template>
  <div class="importPC">
    <el-tabs type="border-card" class="tabs">
      <el-tab-pane label="上传参与方一">
        <div class="uploadButton">
          <div class="upload">
            <!--上传按钮-->
            <el-upload  :action="actionPC1"  :on-success="uploadSucPC1"  :on-error="uploadErr" :on-exceed="uploadMore" :on-remove="uploadRemPC1"  :file-list="fileListPC1" title="点击上传PC1数据EXCEL表格" auto-upload show-file-list :limit="1" :with-credentials="true" style="display: flex;">
              <el-button  type="primary" class="uploadBut">+&nbsp;上传文件</el-button>
            </el-upload>
          </div>

          <div class="save">
            <!--保存区-->
            <el-button type="info" @click="saveCasePC1" :disabled="repeat">保存参与方信息一</el-button>
          </div>
        </div>
        <div class="data" ref="dataPC1">
          <!--表格组件-->
          <el-table ref="envDXF" tooltip-effect="dark" border highlight-current-row  :data="PC1.slice((pageInfoPC1.currentPage-1)*pageInfoPC1.pageSize,pageInfoPC1.currentPage*pageInfoPC1.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table">
            <el-table-column v-for="(item,index) in tableTitlePC12" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
            </el-table-column>
          </el-table>
          <!--分页器-->
          <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfoPC1.currentPage" :page-size="pageInfoPC1.pageSize" :total="PC1.length" @size-change="handleSizeChangePC1" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChangePC1">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="上传参与方二">
        <div class="uploadButton">
          <div class="upload">
            <!--上传按钮-->
            <el-upload  :action="actionPC2"  :on-success="uploadSucPC2"  :on-error="uploadErr" :on-exceed="uploadMore" :on-remove="uploadRemPC2"  :file-list="fileListPC2" title="点击上传PC2数据EXCEL表格" auto-upload show-file-list :limit="1" :with-credentials="true" style="display: flex;">
              <el-button  type="primary" class="uploadBut">+&nbsp;上传文件</el-button>
            </el-upload>
          </div>

          <div class="save">
            <!--保存区-->
            <el-button type="info" @click="saveCasePC2" :disabled="repeat">保存参与方信息二</el-button>
          </div>
        </div>
        <div class="data">
          <!--表格组件-->
          <el-table ref="envDXF" tooltip-effect="dark" border highlight-current-row  :data="PC2.slice((pageInfoPC2.currentPage-1)*pageInfoPC2.pageSize,pageInfoPC2.currentPage*pageInfoPC2.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table" >
            <el-table-column v-for="(item,index) in tableTitlePC12" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
            </el-table-column>
          </el-table>
          <!--分页器-->
          <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfoPC2.currentPage" :page-size="pageInfoPC2.pageSize" :total="PC2.length" @size-change="handleSizeChangePC2" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChangePC2">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="上传动态参与方">
        <div class="uploadButton">
          <div class="upload">
            <!--上传按钮-->
            <el-upload  :action="actionOther"  :on-success="uploadSucPCOther"  :on-error="uploadErr" :on-exceed="uploadMore" :on-remove="uploadRemPCOther"  :file-list="fileListPCOther" title="点击上传DXF数据EXCEL表格" auto-upload show-file-list :limit="1" :with-credentials="true" style="display: flex;">
              <el-button  type="primary" class="uploadBut">+&nbsp;上传文件</el-button>
            </el-upload>
          </div>

          <div class="save">
            <!--保存区-->
            <div class="type">
              信息种类：
              <el-select v-model="msgType"  placeholder="请选择">
                <el-option v-for="item in msg_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <el-button type="info" @click="saveCasePCOther" :disabled="repeat">保存动态参与方信息</el-button>
          </div>
        </div>
        <div class="data">
          <!--表格组件-->
          <el-table ref="envDXF" tooltip-effect="dark" border highlight-current-row  :data="PCOtherBase" :key="table" v-if="msgType === '1'">
            <el-table-column v-for="(item,index) in tableTitlePCOtherBase" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
            </el-table-column>
          </el-table>
          <el-table ref="envDXF" tooltip-effect="dark" border highlight-current-row  :data="PCOther.slice((pageInfoPCOther.currentPage-1)*pageInfoPCOther.pageSize,pageInfoPCOther.currentPage*pageInfoPCOther.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table" v-if="msgType === '2'">
            <el-table-column v-for="(item,index) in tableTitlePCOther" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
            </el-table-column>
          </el-table>
          <!--分页器-->
          <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfoPCOther.currentPage" :page-size="pageInfoPCOther.pageSize" :total="PCOther.length" @size-change="handleSizeChangePCOther" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChangePCOther" v-if="msgType === '2'">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import api from '../assets/javascript/api'
  import qs from 'qs'

  export default {
    name: "导入PC数据",
    data(){
      return{
        /*文件上传的地址*/
        actionPC1:api + 'pc/pc1',
        actionPC2:api + 'pc/pc2',
        actionOther:api + 'move/mof',
        /*通过key刷新表格*/
        table:1,
        /*防止重复点击*/
        repeat:false,
        /*动态参与方信息分类*/
        msgType:'1',
        /*参与方2信息分类*/
        PC2type:"",
        /*上传PC1文件的列表*/
        fileListPC1:[],
        /*上传PC2文件的列表*/
        fileListPC2:[],
        /*上传PCOther文件的列表*/
        fileListPCOther:[],
        /*PC1分页器的参数*/
        pageInfoPC1: {
          currentPage: 1,
          pageSize: 5,
        },
        /*PC2信息分页器的参数*/
        pageInfoPC2: {
          currentPage: 1,
          pageSize: 5,
        },
        /*PCOther信息分页器的参数*/
        pageInfoPCOther: {
          currentPage: 1,
          pageSize: 5,
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*PC1信息表格组件渲染数组*/
        tableTitlePC12:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"参与方编号",width:"120",prop:"participantNumber",show:true},
          {label:"距离碰撞时间",width:"120",prop:"t",show:true},
          {label:"轨迹坐标X",width:"120",prop:"mbdefCogposX",show:true},
          {label:"轨迹坐标Y",width:"120",prop:"mbdefCogposY",show:true},
          {label:"速度",width:"120",prop:"vel",show:true},
          {label:"分速度X",width:"120",prop:"mbdefVelX",show:true},
          {label:"分速度Y",width:"120",prop:"mbdefVelY",show:false},
          {label:"加速度X",width:"120",prop:"mbdefAccX",show:true},
          {label:"加速度Y",width:"120",prop:"mbdefAccY",show:true},
          {label:"是否采取制动(0:否 1:是)",width:"200",prop:"brake",show:true},
          {label:"航向角",width:"120",prop:"heading",show:true},
          {label:"TTC",width:"120",prop:"ttc",show:true},
          {label:"另一参与方轨迹X",width:"140",prop:"otherCoordinateX",show:true},
          {label:"另一参与方轨迹Y",width:"140",prop:"otherCoordinateY",show:true},
          {label:"另一参与方速度",width:"120",prop:"otherSpeed",show:true},
          {label:"另一参与方分速度X",width:"160",prop:"otherSpeedPartX",show:true},
          {label:"另一参与方分速度Y",width:"160",prop:"otherSpeedPartY",show:true},
          {label:"另一参与方加速度X",width:"160",prop:"otherAccelerationX",show:true},
          {label:"另一参与方加速度Y",width:"160",prop:"otherAccelerationY",show:true},
          {label:"另一参与方航向角",width:"160",prop:"otherHeading",show:true},
        ],
        /*PCOther案例信息表格组件渲染数组*/
        tableTitlePCOther:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"障碍物编号",width:"120",prop:"participantNumber",show:true},
          {label:"T",width:"120",prop:"t",show:true},
          {label:"轨迹坐标X",width:"120",prop:"mbdefCogposX",show:true},
          {label:"轨迹坐标Y",width:"120",prop:"mbdefCogposY",show:true},
          {label:"速度",width:"120",prop:"vel",show:true},
          {label:"分速度X",width:"120",prop:"mbdefVelX",show:true},
          {label:"分速度Y",width:"120",prop:"mbdefVelY",show:false},
          {label:"加速度X",width:"120",prop:"mbdefAccX",show:true},
          {label:"加速度Y",width:"120",prop:"mbdefAccY",show:true},
          {label:"是否采取制动(0:否 1:是)",width:"200",prop:"brake",show:true},
          {label:"航向角",width:"120",prop:"heading",show:true}
        ],
        /*PCOther基本信息表格组件渲染数组*/
        tableTitlePCOtherBase:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"障碍物编号",width:"120",prop:"participantNumber",show:true},
          {label:"类型",width:"120",prop:"typeOfParticipant",show:true},
          {label:"障碍物颜色",width:"120",prop:"objectColor",show:true},
          {label:"长度(mm)",width:"120",prop:"vehLength",show:true},
          {label:"宽度(mm)",width:"120",prop:"vehWidth",show:true},
          {label:"高度(mm)",width:"120",prop:"vehHeight",show:true},
          {label:"整备质量(kg)",width:"120",prop:"weight",show:true},
          {label:"重心高度(cm)",width:"120",prop:"cogHeight",show:true},
          {label:"重心到前轴的距离(mm)",width:"150",prop:"cogAxle",show:true},
          {label:"前悬(mm)",width:"120",prop:"vehFrontoverhang",show:true},
          {label:"车辆最前端的高度(cm)",width:"150",prop:"vehShapeH3",show:true},
          {label:"轴距(mm)",width:"120",prop:"wheelbase",show:true},
          {label:"前轮距(mm)",width:"120",prop:"trackwidth1",show:true},
          {label:"后轮距(mm)",width:"120",prop:"trackwidth2",show:true},
          {label:"轮胎宽高比",width:"120",prop:"tyreAspectRatio",show:true},
          {label:"附着系数",width:"120",prop:"coeffFrict",show:true},
          {label:"IXX(kgm^2)",width:"120",prop:"otherAccelerationX",show:true},
          {label:"IYY(kgm^2)",width:"120",prop:"otherAccelerationY",show:false},
          {label:"IZZ(kgm^2)",width:"120",prop:"otherHeading",show:true}
        ],
        /*动态参与方信息种类*/
        msg_type:[
          {
            value:'1',
            label:'基本信息'
          },
          {
            value:'2',
            label:'动态信息'
          }
        ],
        /*PC1信息表格数据*/
        PC1: [],
        /*PC2信息表格数据*/
        PC2: [],
        /*PCOther案例信息表格数据*/
        PCOther: [],
        /*PCOther基本信息表格数据*/
        PCOtherBase: [],
      }
    },
    methods:{
      /*PC1文件上传成功*/
      uploadSucPC1(res){
        if(res.code === "0000"){
          let data = res.data.dynamicPageDto.data;
          /*双重循环遍历返回的数组并存值*/
          for(let i = 0;i < data.length;i++) {
            let obj = [];
            for (let key of Object.keys(data)) {
              obj[key] = data[key];
            }
            this.PC1 = obj;
          }
        }
        else{
          this.$message({
            message: res.msg,
            type: 'error',
            duration:1500
          });
          this.fileListPC1 = [];
        }
      },
      /*PC2文件上传成功*/
      uploadSucPC2(res){
        if(res.code === "0000"){
          if(res.data.car === null){
            this.PC2type = 2;
          }
          else{
            this.PC2type = 1;
          }
          let data = res.data.dynamicPageDto.data;
          /*双重循环遍历返回的数组并存值*/
          for(let i = 0;i < data.length;i++) {
            let obj = [];
            for (let key of Object.keys(data)) {
              obj[key] = data[key];
            }
            this.PC2 = obj;
          }
        }
        else{
          this.$message({
            message: res.msg,
            type: 'error',
            duration:1500
          });
          this.fileListPC2 = [];
        }
      },
      /*PCOther文件上传成功*/
      uploadSucPCOther(res){
        if(res.code === "0000"){
          let moveObstacles = res.data.moveObstacles;
          let moveInformationPageDto = res.data.moveInformationPageDto.data;
          let obj = {};
          for(let key of Object.keys(moveObstacles)){
            obj[key] = moveObstacles[key];
          }
          this.PCOtherBase = [];
          this.PCOtherBase[0] = obj;
          let PCOther = [];
          for(let i = 0; i <moveInformationPageDto.length; i++){
            let obj = {};
            for(let key of Object.keys(moveInformationPageDto[i])){
              obj[key] = moveInformationPageDto[i][key];
            }
            PCOther[i] = obj;
          }
          this.PCOther = PCOther;
        }
        else{
          this.$message({
            message: res.msg,
            type: 'error',
            duration:1500
          });
          this.fileListPCOther = [];
        }
      },
      /*文件上传失败*/
      uploadErr(err){
        this.$message({
          message: err.msg,
          type: 'error',
          duration:1500
        });
      },
      /*文件个数大于1*/
      uploadMore(){
        this.$message({
          message: '一次仅限上传一个文件',
          type: 'error',
          duration:1000
        });
      },
      /*PC1移除文件列表*/
      uploadRemPC1(){
        this.fileListPC1 = [];
        this.$message({
          message: '删除成功',
          type: 'success',
          duration:1000
        });
      },
      /*PC2移除文件列表*/
      uploadRemPC2(){
        this.fileListPC2 = [];
        this.$message({
          message: '删除成功',
          type: 'success',
          duration:1000
        });
      },
      /*PC1移除文件列表*/
      uploadRemPCOther(){
        this.fileListPCOther = [];
        this.$message({
          message: '删除成功',
          type: 'success',
          duration:1000
        });
      },
      /*保存PC1数据*/
      saveCasePC1(){
        /*禁用按钮防止误触*/
        this.repeat = true;
        let postData = qs.stringify({
          caseNumber:this.PC1[0].caseNumber
        });
        this.$http.post(
          '/pc/pc1/s1',
          postData,
          {
            headers:
              {'Content-Type':'application/x-www-form-urlencoded'}
          })
          .then((res)=>{
            this.$message({
              message: "保存成功",
              type: 'success',
              center: true,
              duration:1500
            });
            this.fileListPC1 = [];
            this.repeat = false;
          })
          .catch((error)=>{
            console.log(error);
            this.repeat = false;
          })
      },
      /*保存PC2数据*/
      saveCasePC2(){
        /*禁用按钮防止误触*/
        this.repeat = true;
        let  postData = qs.stringify({
            caseNumber:this.PC2[0].caseNumber,
            type:this.PC2type
          });
        this.$http.post(
          '/pc/pc2/s2',
          postData,
          {
            headers:
              {'Content-Type':'application/x-www-form-urlencoded'}
          })
          .then((res)=>{
            this.$message({
              message: "保存成功",
              type: 'success',
              center: true,
              duration:1500
            });
            this.fileListPC2 = [];
            this.repeat = false;
          })
          .catch((error)=>{
            console.log(error);
            this.repeat = false;
          })
      },
      /*保存PCOther数据*/
      saveCasePCOther(){
        /*禁用按钮防止误触*/
        this.repeat = true;
        let  postData = qs.stringify({
          caseNumber:this.PCOtherBase[0].caseNumber,
          participantNumber:this.PCOtherBase[0].participantNumber
        });
        this.$http.post(
          '/move/move',
          postData,
          {
            headers:
              {'Content-Type':'application/x-www-form-urlencoded'}
          })
          .then((res)=>{
            this.$message({
              message: "保存成功",
              type: 'success',
              center: true,
              duration:1500
            });
            this.fileListPCOther = [];
            this.repeat = false;
          })
          .catch((error)=>{
            console.log(error);
            this.repeat = false;
          })
      },
      /* PC1信息分页大小切换*/
      handleSizeChangePC1(val) {
        this.pageInfoPC1.pageSize = val;
      },
      /*PC1信息分页切换*/
      handleCurrentChangePC1(val) {
        this.pageInfoPC1.currentPage = val;
      },
      /* PC2信息分页大小切换*/
      handleSizeChangePC2(val) {
        this.pageInfoPC2.pageSize = val;
      },
      /*PC2信息分页切换*/
      handleCurrentChangePC2(val) {
        this.pageInfoPC2.currentPage = val;
      },
      /* PCOther信息分页大小切换*/
      handleSizeChangePCOther(val) {
        this.pageInfoPCOther.pageSize = val;
      },
      /*PCOther信息分页切换*/
      handleCurrentChangePCOther(val) {
        this.pageInfoPCOther.currentPage = val;
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.dataPC1.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      }
    },
    mounted(){
      /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
      /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.dataPC1.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
    }
  }
</script>

<style scoped>
  .importPC{
    width: 100%;
    height: calc(100% - 34px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tabs{
    width: 100%;
    height: 100%;
    border: none;
  }
  .el-tab-pane{
    width: 100%;
    height: 100%;
  }
  .uploadButton{
    width: 100%;
    height: 50px;
    background-color: #E9EBEE;
    display: flex;
    align-items: center;
  }
  .data{
    width: 100%;
    height: calc(100% - 50px);
  }
  .upload{
    display: flex;
    align-items: center;
    height: 100%;
    width: 35%;
    padding-left: 2%;
  }
  .save{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    width: 60% ;
    padding-right: 2%;
  }
  .type{
    height: 100%;
    width: 43%;
    display: flex;
    align-items: center;
    color: gray;
  }
  .uploadBut{
    background-color: cadetblue;
  }
  .el-pagination{
    text-align: center;
  }
</style>
<style>
  .el-tabs__content{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/importData/importPC.vue